import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

/**
 * アンカー処理をするクラス
 */
class Anchor {
  constructor(el) {
    this.DOM = {};
    this.DOM.el = el;
    if (!this.DOM.el) return;

    this.init();
  }

  init() {
    this.onClick = (e) => this._onClick(e);
    this.DOM.el.addEventListener('click', this.onClick);
  }

  _onClick(e) {
    // 1. クリックされたリンク先URL情報をパース
    const href = this.DOM.el.getAttribute('href');
    if (!href) return;

    const linkUrl = new URL(href, window.location.href);
    const targetId = linkUrl.hash; // 例: "#faq"

    // 2. 「同じページのアンカー」でない場合は、通常のページ遷移（何もしない）
    const isSameHost = linkUrl.host === window.location.host;
    const isSamePath = linkUrl.pathname === window.location.pathname;
    if (!isSameHost || !isSamePath || !targetId) {
      return; 
    }

    // 3. スムーススクロールを実行する要素があるか確認
    const $section = document.querySelector(targetId);
    if (!$section) return; // 安全ガード：要素がない場合は処理を抜ける

    // ここで初めてデフォルトイベント（遷移）をキャンセルする
    e.preventDefault();

    // 4. スクロール位置の計算
    // const header = document.querySelector('[data-header]');
    // const offset = header.clientHeight;
    // const BUFFER = 10;
    // const rect = $section.getBoundingClientRect();
    // const y = rect.top + window.scrollY - offset - BUFFER

    // 5. スクロール
    // const duration = this.DOM.el.classList.contains('js-no-scroll') ? 0 : 0.4;
    // gsap.to(window, {
    //   duration,
    //   scrollTo: { y }
    // });

    // ★ CSSの scroll-margin-top の値（px換算値）を動的に取得
    const computedStyle = window.getComputedStyle($section);
    const scrollMarginTop = parseFloat(computedStyle.scrollMarginTop) || 0;

    const duration = this.DOM.el.classList.contains('js-no-scroll') ? 0 : 0.4;

    gsap.to(window, {
      duration,
      scrollTo: {
        y: $section,
        offsetY: scrollMarginTop // ★ CSSから取得した scroll-margin-top 分を引く
      }
    });

  }

  // メモリリーク防止用の解除メソッドを定義
  dispose() {
    this.DOM.el.removeEventListener('click', this.onClick);
  }
}

/**
 * アンカーインスタンスの生成
 */
export class Anchors {
  constructor() {
    this.DOM = {};
    this.DOM.links = document.querySelectorAll('a');
    this.anchors = [];

    this.init();
  }

  init() {
    for (const link of this.DOM.links) {
      const href = link.getAttribute('href');
      if (!href) continue;

      // 「現在のページ内でのみ完結するアンカー」または「ハッシュ付きの絶対パス」を判別して登録
      if (this.isAnchorLink(link)) {
        this.anchors.push(new Anchor(link));
      }
    }
  }

  // アンカーリンク判定ユーティリティ
  isAnchorLink(link) {
    const href = link.getAttribute('href');
    // #のみ（空リンク等）や、javascript: などの擬似プロトコルを除外
    if (href === '#' || href.startsWith('javascript:')) return false;

    // 「#から始まる」または「ドメインが同じかつハッシュを持っている」場合に登録対象とする
    try {
      const linkUrl = new URL(href, window.location.href);
      return linkUrl.hash !== '';
    } catch (e) {
      return false;
    }
  }

  destroy() {
    for (const anchor of this.anchors) {
      anchor.dispose(); 
    }
    this.anchors = [];
  }
}
